import apiURL from "../config/environment";

export const getCyclistsSiteCount = async () => {
    const response = await fetch(apiURL + "dashboard/cyclist-site-count")
    if (!response.ok) {
        throw new Error("Network response was not ok");
    }
    return await response.json();
}
